import React from 'react';
import { FaExclamationCircle, FaTimes } from 'react-icons/fa';

const ErrorMessage = ({ message, onClose, type = 'error' }) => {
  const typeStyles = {
    error: {
      bg: 'bg-red-50',
      border: 'border-red-500',
      text: 'text-red-800',
      icon: 'text-red-500'
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-500',
      text: 'text-yellow-800',
      icon: 'text-yellow-500'
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-500',
      text: 'text-blue-800',
      icon: 'text-blue-500'
    }
  };

  const styles = typeStyles[type] || typeStyles.error;

  return (
    <div className={`${styles.bg} border-l-4 ${styles.border} p-4 rounded mb-4`}>
      <div className="flex items-start">
        <FaExclamationCircle className={`${styles.icon} mr-3 mt-0.5 flex-shrink-0`} />
        <div className="flex-1">
          <p className={`${styles.text} text-sm`}>{message}</p>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className={`${styles.text} hover:opacity-75 ml-3`}
          >
            <FaTimes />
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;
